import validate from "/app/node_modules/.pnpm/nuxt@3.18.0_@capacitor+preferences@7.0.1_@capacitor+core@7.4.2__@netlify+blobs@9.1.2_@p_bfa5f24d81766dba992c52a6d53e701f/node_modules/nuxt/dist/pages/runtime/validate.js";
import tabletmode_45global from "/app/packages/frontend/app/middleware/tabletmode.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.18.0_@capacitor+preferences@7.0.1_@capacitor+core@7.4.2__@netlify+blobs@9.1.2_@p_bfa5f24d81766dba992c52a6d53e701f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  tabletmode_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  anonymous: () => import("/app/packages/frontend/app/middleware/anonymous.ts"),
  auth: () => import("/app/packages/frontend/app/middleware/auth.ts"),
  "board-anonymous": () => import("/app/packages/frontend/app/middleware/board_anonymous.ts"),
  "board-auth": () => import("/app/packages/frontend/app/middleware/board_auth.ts"),
  superadmin: () => import("/app/packages/frontend/app/middleware/superadmin.ts")
}